/* eslint-disable import/prefer-default-export */
import { injectLocal } from '@vueuse/core';
import { PRODUCT_ID_REPOSITORY, PRODUCT_DATA_REPOSITORY } from '../constants';

/**
 * * Product Data Injector
 * ! Dependency Injection of product data
 * Reduces complexity, removes prop drilling, increases performance
 * Plus, allows avoid unnecessary computed wraps
 */
export const useProduct = () => {
  /**
   * @type {ProductId|undefined}
   */
  const productId = injectLocal(PRODUCT_ID_REPOSITORY);
  if (typeof productId === 'undefined') {
    throw new TypeError('useProduct() is called without provider.');
  }

  /**
   * @type {Product}
   */
  const productData = injectLocal(PRODUCT_DATA_REPOSITORY);

  return {
    productId,
    productData,
  };
};
